import { createSelector } from "reselect";
import { RootState } from "../reducers";

type State = RootState;

const getAllOrders = ({ orders }: State) => orders.all;

const getPastOrders = ({ orders }: State) => {
  return orders && Array.isArray(orders.all) ? orders.all : [];
};
const getPastOrdersPaginationCount = ({ orders }: State): number =>
  orders.currentPage;

const getHasMoreOrders = ({ orders }: State): boolean =>
  Boolean(orders.all?.length);

const getLastPlacedOrder = createSelector([getAllOrders], (allOrders) => {
  const [recentOrder] = allOrders.slice(-1);
  return recentOrder;
});

const getOrdersLoading = ({ orders }: State) => orders.ordersLoading;

const getIsOrderProcessing = ({ orders }: State) => orders.isOrderProcessing;

export {
  getPastOrders,
  getAllOrders,
  getLastPlacedOrder,
  getPastOrdersPaginationCount,
  getOrdersLoading,
  getHasMoreOrders,
  getIsOrderProcessing,
};
